export default __webpack_public_path__ + "static/media/gestionale-agenda.e1f45849.png";